const isCryptoAvailable = () => !!window.crypto?.subtle?.digest;

const convertToHex = hashBuffer => {
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  return hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
};

const hashString = async id => {
  try {
    if (!isCryptoAvailable()) {
      return false;
    }

    const messageBuffer = new TextEncoder().encode(id);
    const hashBuffer = await crypto.subtle.digest("SHA-256", messageBuffer);

    return convertToHex(hashBuffer);
  } catch (e) {
    return false;
  }
};

export default hashString;
